import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const InstagramSocialHeaderButton = Scrivito.provideObjClass(
  "InstagramSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default InstagramSocialHeaderButton;
